import CartItem from "@api/types/cart-item";
import { FC, useContext, useState } from "react";

import UserContext, { UserConsumer } from "@components/UserContext";

const CartQuantityPicker: FC<{ item: CartItem }> = ({ item }) => {
  const [quantity, setQuantity] = useState(item.quantity);
  const { changeProduct } = useContext(UserContext);

  return (
    <>
      <div className="CartQuantityPicker">
        <div className="entry">
          <input
            data-cy="quantity"
            type="number"
            min="1"
            step="1"
            value={quantity}
            onChange={({ target: { value } }) => {
              const intValue = parseInt(value);
              setQuantity(intValue);
              if (!isNaN(intValue)) changeProduct({ id: item.id, quantity: intValue });
            }}
          />
        </div>
        <div>
          <UserConsumer>
            {({ removeProduct }) => (
              <a data-cy="cart-item-remove" className="remove" onClick={() => removeProduct({ id: item.id })}>
                remove
              </a>
            )}
          </UserConsumer>
        </div>
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .CartQuantityPicker {
          }

          .remove {
            cursor: pointer;
          }

          .entry {
            margin: 0 0 10px 0;
          }
        `}
      </style>
    </>
  );
};

export default CartQuantityPicker;
